import { CustomGridColumns } from '../../CustomDataGrid';

export const cbenefColunm: CustomGridColumns[] = [
  {
    field: 'cod_beneficio_fiscal',
    headerName: 'Cód. Benefício Fiscal',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
];
